import { Link } from 'react-router-dom';

import styled from 'styled-components';

export const Root = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.palette.brown400};
  padding: 8px;
  margin: -8px;
`;
